import { createStructuredSelector } from 'reselect'

import {
  ASSESSMENT_LIST,
  ASSESSMENT_LIST_SUCCESS, 
  ASSESSMENT_LIST_ERROR,
  ASSESSMENT_PAGE_SET,
  ASSESSMENT_SEARCH_SET,
  ASSESSMENT_SEARCH_ASSESSMENT_TYPE,
  ASSESSMENT_SEARCH_ASSESSMENT_TYPE_SUCCESS,
  ASSESSMENT_SEARCH_ASSESSMENT_TYPE_ERROR, 
  ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY,
  ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_SUCCESS,
  ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_ERROR, 
  ASSESSMENT_SEARCH_CHANGE,
  ASSESSMENT_ADD_SET,
  ASSESSMENT_ADD_MODAL_SET,
  ASSESSMENT_ADD,
  ASSESSMENT_ADD_SUCCESS,
  ASSESSMENT_ADD_ERROR,
  ASSESSMENT_ADD_CHANGE,
  ASSESSMENT_DETAIL,
  ASSESSMENT_DETAIL_SUCCESS,
  ASSESSMENT_DETAIL_ERROR,
  ASSESSMENT_VIEW_MODAL_SET,
  ASSESSMENT_EDIT_CHANGE,
  ASSESSMENT_EDIT_MODAL_SET,
  ASSESSMENT_UPDATE,
  ASSESSMENT_UPDATE_SUCCESS,
  ASSESSMENT_UPDATE_ERROR,
  ASSESSMENT_VIEW_TAB_SET,
  ASSESSMENT_UPLOAD_SET, 
  ASSESSMENT_UPLOAD_SET_SUCCESS,
  ASSESSMENT_UPLOAD_SET_ERROR,
  ASSESSMENT_UPLOAD_RESET
} from '../../actions';

export const NAME = 'assessment';

export const AssessmentList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: ASSESSMENT_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const AssessmentListSuccess = (data) => ({
  type: ASSESSMENT_LIST_SUCCESS,
  payload: data
});

export const AssessmentListError = (error) => ({
  type: ASSESSMENT_LIST_ERROR,
  payload: error
});

export const AssessmentPageSet = (data) => ({
  type: ASSESSMENT_PAGE_SET,
  payload: data
});

export const AssessmentSearchSet = (data) => ({
  type: ASSESSMENT_SEARCH_SET,
  payload: data
});

export const AssessmentSearchAssessmentType = (data) => ({
  type: ASSESSMENT_SEARCH_ASSESSMENT_TYPE,
  payload: data
});

export const AssessmentSearchAssessmentTypeSuccess = (message) => ({
  type: ASSESSMENT_SEARCH_ASSESSMENT_TYPE_SUCCESS,
  payload: message
});

export const AssessmentSearchAssessmentTypeError = (error) => ({
  type: ASSESSMENT_SEARCH_ASSESSMENT_TYPE_ERROR,
  payload: error
}); 

export const AssessmentSearchAssessmentCategory = (data) => ({
  type: ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY,
  payload: data
});

export const AssessmentSearchAssessmentCategorySuccess = (message) => ({
  type: ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_SUCCESS,
  payload: message
});

export const AssessmentSearchAssessmentCategoryError = (error) => ({
  type: ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_ERROR,
  payload: error
}); 

export const AssessmentSearchChangeSet = (data) => ({
  type: ASSESSMENT_SEARCH_CHANGE,
  payload: data
});

export const AssessmentAddChangeSet = (data) => ({
  type: ASSESSMENT_ADD_CHANGE,
  payload: data
});

export const AssessmentAddSet = (data) => ({
  type: ASSESSMENT_ADD_SET,
  payload: data
});

export const AssessmentAddModalSet = (data) => ({
  type: ASSESSMENT_ADD_MODAL_SET,
  payload: data
});

export const AssessmentAdd = (data) => ({
  type: ASSESSMENT_ADD,
  payload: data
});

export const AssessmentAddSuccess = (message) => ({
  type: ASSESSMENT_ADD_SUCCESS,
  payload: message
});

export const AssessmentAddError = (error) => ({
  type: ASSESSMENT_ADD_ERROR,
  payload: error
});

export const AssessmentDetail = (data) => ({
  type: ASSESSMENT_DETAIL,
  payload: data
});

export const AssessmentDetailSuccess = (data) => ({
  type: ASSESSMENT_DETAIL_SUCCESS,
  payload: data
});

export const AssessmentDetailError = (error) => ({
  type: ASSESSMENT_DETAIL_ERROR,
  payload: error
});

export const AssessmentViewModalSet = (data) => ({
  type: ASSESSMENT_VIEW_MODAL_SET,
  payload: data
});

export const AssessmentEditModalSet = (data) => ({
  type: ASSESSMENT_EDIT_MODAL_SET,
  payload: data
});

export const AssessmentEditChangeSet = (data) => ({
  type: ASSESSMENT_EDIT_CHANGE,
  payload: data
});

export const AssessmentUpdate = (data) => ({
  type: ASSESSMENT_UPDATE,
  payload: data
});

export const AssessmentUpdateSuccess = (message) => ({
  type: ASSESSMENT_UPDATE_SUCCESS,
  payload: message.message
});

export const AssessmentUpdateError = (error) => ({
  type: ASSESSMENT_UPDATE_ERROR,
  payload: error
});

export const AssessmentViewTabSet = (data) => ({
  type: ASSESSMENT_VIEW_TAB_SET,
  payload: data
});

export const AssessmentUploadSet = (file) => ({
  type: ASSESSMENT_UPLOAD_SET,
  payload: { file },
});

export const AssessmentUploadSetSuccess = (items) => ({
  type: ASSESSMENT_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const AssessmentUploadSetError = (error) => ({
  type: ASSESSMENT_UPLOAD_SET_ERROR,
  payload: error,
});

export const AssessmentUploadReset= () => ({
  type: ASSESSMENT_UPLOAD_RESET
});

const assessment = (state) => state[NAME];

export const AssessmentSelector = createStructuredSelector({
  assessment
})
 